import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import TextHeadingThree from '../atoms/TextHeadingThree';
import FormButton from '../atoms/FormButton';
import TextParagraph from '../atoms/TextParagraph';

//Returning the component
class YourPlan extends Component {
	render() {
		return (
			<div className="ourPlan">
				<div className="ourPlan__current">
					<TextHeadingThree classType="text-bold color-primary" text="Your plan" />
					<TextParagraph classType="text-bold" text={this.props.currentPlan} />
				</div>
				<div className="ourPlan__features">
					<ul className="margin-y-xs">
						<li>{this.props.features}</li>
						<li>{this.props.features}</li>
						<li>{this.props.features}</li>
						<li>{this.props.features}</li>
						<li>{this.props.features}</li>
					</ul>
				</div>
				<TextParagraph classType="color-accent1" text={this.props.renewal} />
				<FormButton text="Change or cancel" onClick={this.props.onClick} />
			</div>
		)
	}
}

//Making sure that it has a text property when it's declared
YourPlan.propTypes = {
	currentPlan: PropTypes.string,
	features: PropTypes.string,
	renewal: PropTypes.string,
}

export default YourPlan;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/YourPlan.jsx